import {Box} from '@mui/material'
import React from 'react'

interface EditableFieldProps {
  inputRef: React.RefObject<HTMLInputElement>
  value: string
  range: {
    min: number
    max: number
    step: number
  }
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onBlur: () => void
  onKeyPress: (event: React.KeyboardEvent) => void
  'data-test-id'?: string
}

/**
 * Editable input field for quantity with a blue cursor indicator.
 * Private component used internally by QuantityInput.
 */
export const RangeEditableField: React.FC<EditableFieldProps> = ({
  inputRef,
  value,
  range,
  onChange,
  onBlur,
  onKeyPress,
  'data-test-id': dataTestId
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }}
    >
      {/* Blue cursor indicator when editing */}
      <Box
        sx={{
          width: '2px',
          height: '22px',
          backgroundColor: '#016ad4',
          borderRadius: '100px',
          position: 'absolute',
          left: 0,
          zIndex: 1
        }}
      />
      <input
        ref={inputRef}
        type="number"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        min={range.min}
        max={range.max}
        step={range.step}
        style={{
          fontFamily: 'Inter',
          fontWeight: 500,
          fontSize: '16px',
          lineHeight: '24px',
          color: '#29333d',
          textAlign: 'center',
          border: 'none',
          background: 'transparent',
          outline: 'none',
          padding: 0,
          margin: 0,
          width: '100%',
          minWidth: '60px',
          paddingLeft: '8px'
        }}
        data-test-id={dataTestId}
      />
    </Box>
  )
}
